// ErrorModal.js
import React from 'react';

function ErrorModal({ message }) {
    return (
        <div className="error-modal">
            <h2>Error</h2>
            <p>{message}</p>
        </div>
    );
}

export default ErrorModal;
